import React from 'react';
import '../css/contact.css';
import Overlay from "../components/Overlay";

const Contact = (props) => {
  return (
    <div className="contact" id={props.id}>
        <img src={require("../images/teachpadding.svg")} alt="Natalie Scalia" className="bottom-wave"/>
        <div className="contact-details">
          <h2>Contact me</h2>
          <p className="details">Number: 0400386838</p>
          <p className="details">Email: nataliescalia.music@gmail.com</p>
          <Overlay btnname="Services"/>
        </div>
    </div>
  );
};

export default Contact;